import { Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomAssessmentsService } from '../../services/custom-assessments.service';
import { CustomAssessment } from '../../services/model';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationComponent } from '../../components/navigation/navigation.component';

type CustomEditingAssessment = CustomAssessment & {
  editing: boolean;
};

@Component({
  selector: 'app-edit-assessment-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    NavigationComponent,
  ],
  templateUrl: './edit-assessment-list.component.html',
  styleUrl: './edit-assessment-list.component.scss',
})
export class EditAssessmentListComponent {
  location: Location = inject(Location);
  customAssessmentsService = inject(CustomAssessmentsService);
  protected router: Router = inject(Router);
  protected route: ActivatedRoute = inject(ActivatedRoute);

  displayedColumns: string[] = ['visibility', 'name', 'action'];

  addNewActive: WritableSignal<boolean> = signal(false);
  customAssessmentList: Signal<CustomAssessment[]> = this.customAssessmentsService.customAssessmentList;
  customEditingAssessmentList: Signal<CustomEditingAssessment[]> = computed(() => {
    const list = this.customAssessmentsService.customAssessmentList().map(item => ({ ...item, editing: false }));
    list.sort((a, b) => a.id! - b.id!);
    if (this.addNewActive()) {
      const maxId = this.getMaxId(); // Ermittlung der höchsten ID
      const newAssessment: CustomEditingAssessment = {
        id: maxId + 1, // Vergabe der nächsthöheren ID
        visible: true,
        shortName: '',
        fullName: '',
        sideDistinction: false,
        editing: true, // Das neue Assessment ist sofort im Bearbeitungsmodus
      };
      list.push(newAssessment);
    }
    return list;
  });

  constructor() {
    this.customAssessmentsService.getCustomAssessments();
  }

  editAssessment(assessment: CustomEditingAssessment): void {
    assessment.editing = true;
  }

  saveAssessment(assessment: CustomEditingAssessment): void {
    console.log('CustomEditingAssessment speichern:', assessment);
    // assessment.editing = false;
    const { editing, ...customAssessment } = assessment;
    // @TODO: kürzel muss eindeutig sein!
    // @TODO: id darf nicht neu vergeben werden, wenn gelöscht wurde, es sei denn wir lösen konsistenz über das kürzel

    if (customAssessment._documentId) {
      this.customAssessmentsService.updateCustomAssessment(customAssessment).then(result => {
        console.log('CustomAssessment saved:', result);
      });
    } else {
      this.customAssessmentsService.createCustomAssessment(customAssessment).then(result => {
        console.log('CustomAssessment created:', result);
      });

      this.addNewActive.set(false);
    }
  }

  toggleVisibility(assessment: CustomEditingAssessment): void {
    assessment.visible = !assessment.visible;
    console.log('Assessment getogglet:', assessment);
    if (assessment.editing) {
      // // unveränderten Zustand mit getoggelter Visibility speichern
      // const unchangedAssessment: CustomAssessment[] = this.customAssessmentList().filter(
      //   item => item.id === assessment.id
      // );
      // if (unchangedAssessment.length === 1) {
      //   this.saveAssessment(unchangedAssessment[0] as CustomEditingAssessment);
      // }
    } else {
      this.saveAssessment(assessment);
    }
  }

  cancel(assessment: CustomEditingAssessment): void {
    assessment.editing = false;
    // unveränderten Zustand wieder herstellen
    const unchangedAssessment: CustomAssessment[] = this.customAssessmentList().filter(
      item => item.id === assessment.id
    );
    if (unchangedAssessment.length === 1) {
      assessment.shortName = unchangedAssessment[0].shortName;
      assessment.fullName = unchangedAssessment[0].fullName;
    }

    this.addNewActive.set(false);
  }

  // Methode zum Hinzufügen eines neuen Assessments
  addNewAssessment(): void {
    this.addNewActive.set(true);
  }

  // Methode zum Hinzufügen eines neuen Assessments
  deleteAssessment(customAssessment: CustomEditingAssessment): void {
    this.customAssessmentsService.deleteCustomAssessment(customAssessment).then(result => {
      console.log('CustomAssessment deleted:', result);
    });
  }

  // Methode zur Ermittlung der höchsten ID in der Liste
  getMaxId(): number {
    if (this.customAssessmentList().length === 0) {
      return 0; // Falls keine Einträge vorhanden sind, starte bei 0
    }
    return Math.max(...this.customAssessmentList().map(assessment => assessment.id || 0));
  }

  onNavigateBack() {
    this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
  }
}
